import React from 'react';

import { AddButton } from '../../../../components/Button';
import CommonDataGrid from '../../../../components/CommonDataGrid';
import { Column } from '../../../../components/CommonDataGrid/props';
import Loader from '../../../../components/Loader';
import DeleteImg from '../../../../images/SideBar/Delete';
import EditImg from '../../../../images/SideBar/Edit';
import ViewImg from '../../../../images/SideBar/View';
import { formatDate, styles } from '../../../../util/constant';
import useProject from '../useProject';
import EditProjectIndex from './EditProject/index';
import ViewProjectIndex from './ViewProject';

const projectRowId = (row: { _id?: string; id?: string }) =>
  String(row._id ?? row.id ?? '');

const Project: React.FC = () => {
  const {
    selectedProjectId,
    selectedProjectView,
    projectData,
    showConfirmation,
    handleCancelStatusUp,
    updateScreen,
    handleConfirmStatusUp,
    handleEdit,
    handleAdd,
    handleStatusUp,
    handleView,
    handleDateFilter,
    setSearch,
    setPage,
    page,
    loading,
    totalPage,
  } = useProject();

  const columns: Column[] = [
    {
      field: "name",
      headerName: "Project Name",
      width: 50,
      align: "center",
    },
    {
      field: "description",
      headerName: "Description",
      width: 50,
      align: "center",
    },
    {
      field: "gitfeld",
      headerName: "Git Link",
      width: 50,
      align: "center",
    },
    {
      field: "createdAt",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      headerName: "Created",
      align: "center",
      width: 50,
    },
    {
      field: "status",
      renderCell: (params: any) => (
        <p className={`${styles[params.value]}`}>{params.value}</p>
      ),
      headerName: "Status",
      width: 50,
      align: "center",
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 50,
      align: "center",
      renderCell: (params: any) => (
        <div className="flex space-x-2 justify-center">
          <button
            onClick={() => handleEdit(projectRowId(params.row))}
            className="text-fontColor hover:text-primary-2"
            type="button"
          >
            <EditImg />
          </button>
          <button
            onClick={() => handleStatusUp(projectRowId(params.row))}
            className="text-red-500 hover:text-red-700"
            type="button"
          >
            <DeleteImg />
          </button>
          <button
            onClick={() => handleView(params.row)}
            className="text-gray-500 hover:text-gray-700"
            type="button"
          >
            <ViewImg />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="m-5">
        {loading && <Loader />}
        <div>
          {selectedProjectView ? (
            <ViewProjectIndex
              projectId={selectedProjectView}
              setMethod={() => updateScreen("view")}
            />
          ) : selectedProjectId ? (
            <EditProjectIndex
              projectId={selectedProjectId}
              setMethod={() => updateScreen("edit")}
            />
          ) : (
            <>
              <div className="grid justify-items-end -mb-16 mr-5">
                <AddButton
                  onClick={handleAdd}
                  className="  "
                  children="+"
                  type="button"
                />
              </div>
              <CommonDataGrid
                tableName="Project"
                rows={projectData}
                columns={columns}
                getRowId={(row) => projectRowId(row)}
                showConfirmation={showConfirmation}
                confirmationMessage="Are you sure you want to Status Update this Project?"
                onCancelDelete={handleCancelStatusUp}
                onConfirmDelete={handleConfirmStatusUp}
                loading={!projectData}
                onDateFilter={handleDateFilter}
                addButton
                setSearchBar={setSearch}
                setCurrentPage={setPage}
                currentPage={page}
                totalPages={totalPage}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Project;
